import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'Игры Онлайн Бесплатно Без Регистрации | Gamezop',
  desc: 'Играйте в игры онлайн бесплатно без регистрации или загрузок на Gamezop. Выбирайте из 200+ игры бесплатно онлайн, включая экшн, приключения, аркады, головоломки, гонки и многое другое.',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'Игры Онлайн Бесплатно Без Регистрации',
    body: {
      text: [
        `Играйте в лучшие бесплатные онлайн-игры на Gamezop без скачивания!
        Выбирайте любимую игру из списка и начинайте играть всего за несколько секунд. У нас более 200+ бесплатных популярных игр в категориях экшен, приключения, аркады, головоломки, гонки и других. Хотите играть на мобильном устройстве, ПК или iOS? Gamezop предлагает лучшие игры для вас!`,
        `Если вам скучно, Gamezop предлагает множество увлекательных игр. Защищайте крепости от врагов, стреляйте по мишеням или перепрыгивайте препятствия. Попробуйте захватывающие игры, такие как Kingdom Fight, City Cricket, Fruity Fiesta и другие! Наши игры подходят для детей, взрослых и пожилых людей.`,
        `Для игры вам не нужен мощный компьютер. Наши игры работают без установки и скачивания – достаточно браузера и интернет-соединения. Играть можно на ПК, ноутбуке, Chromebook, смартфоне, планшете и других устройствах.`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: `Какие лучшие бесплатные игр онлайн?`,
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: `В какие бесплатные онлайн игры можно поиграть с друзьями?`,
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Какие жанры игр самые популярные?',
    body: {
      text: [],
      list: [
        {
          name: 'Безумные игры',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'Настольные игры',
          nameEn: 'Crazy games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'Приключенческие игры',
          nameEn: 'Crazy games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'Головоломки',
          nameEn: 'Crazy games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'Стрелялки',
          nameEn: 'Crazy games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Что такое Gamezop?',
    body: {
      text: [
        `Gamezop — это платформа «подключи и работай» для игр, которая позволяет приложениям и сайтам легко интегрировать казуальные игры, повышая вовлеченность пользователей. Помимо игр, Gamezop управляет несколькими специализированными платформами: Quizzop для интерактивных викторин, Astrozop для астрологических прогнозов и предсказаний, Criczop для живых результатов и обновлений по крикету и Feedzop для агрегирования новостей. Вместе эти платформы предлагают разнообразный набор контент-решений, которые удовлетворяют интересы широкой аудитории.`,
        `С более чем 8000 интеграциями в более чем 70 странах, Gamezop и ее дочерние платформы заслужили доверие таких мировых брендов, как Amazon, Samsung Internet, Snap, Tata Play, AccuWeather и Paytm. Эти решения не только способствуют повышению вовлеченности пользователей, но и открывают новые возможности для рекламной монетизации. Интеграция занимает всего 30 минут и позволяет приложениям и сайтам предлагать привлекательный контент, включая игры, викторины, астрологию, крикет и новости.`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'Часто задаваемые вопросы',
  faqs: [
    {
      tag: 'h3',
      title: 'Могу ли я играть в игры бесплатно без установки?',
      body: ['Да, вы можете играть в игры бесплатно без установки или скачивания.'],
    },
    {
      tag: 'h3',
      title: 'Нужно ли регистрироваться, чтобы играть?',
      body: [
        'Нет, вам не нужно регистрироваться, чтобы играть в игры на Gamezop.com. Вы можете начать играть мгновенно без какой-либо регистрации.',
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/ru',
      },
    },
    {
      tag: 'h3',
      title: `Безопасно ли играть в онлайн-игры?`,
      body: [
        'Да, играть в онлайн-игры на проверенных платформах, таких как Gamezop, безопасно. Наши игры не требуют скачивания, что сводит к минимуму риски вредоносных программ. Мы уделяем особое внимание безопасности пользователей, обеспечивая комфортный игровой процесс без угроз вашей конфиденциальности или безопасности устройства.',
      ],
    },
    {
      tag: 'h3',
      title: 'Действительно ли игры бесплатно бесплатны?',
      body: [
        'Да, игры бесплатно на Gamezop действительно бесплатны. Однако для поддержки платформы в играх могут отображаться рекламные объявления.',
      ],
    },
    {
      tag: 'h3',
      title: 'Есть ли игры бесплатно для пожилых людей?',
      body: [
        'Да, у нас есть игры бесплатно для пожилых людей, которые можно играть онлайн, включая Sudoku Classic, Solitaire Gold, Chess Grandmaster и другие.',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
